import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ChatMessageListUI from './ChatMessageListUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ChatMessageListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      replyMode: false,
      selectedUserId: null,
      selectedAccountId: null,
      selectedPhone: null,
      downloadMode: false,
      selectedMesgDate: null,
      // upload
      fileUploadMode: false,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: null,
      fileUploadSubmitted: false,
      //
      statusUpdateMode: false,
      setFollowUpMode: false,
      checked: false
    }
  }

  render() {
    return (
      <ChatMessageListUI
        context={this.props.context}
        account={this.props.account}
        userMessageList={this.props.userMessageList}
        errorList={this.props.errorList}
        onRefreshClick={this.props.onRefreshClick}
        // send message
        replyMode={this.state.replyMode}
        onReplyClick={this.onReplyClick}
        onReplyCancel={() => { (this.setState({ replyMode: false })) }}
        selectedUserId={this.state.selectedUserId}
        selectedAccountId={this.state.selectedAccountId}
        selectedPhone={this.state.selectedPhone}
        // download
        onDownloadClick={this.onDownloadClick}
        downloadMode={this.state.downloadMode}
        selectedMesgDate={this.state.selectedMesgDate}
        // upload
        fileUploadMode={this.state.fileUploadMode}
        fileUploadSubmitted={this.state.fileUploadSubmitted}
        fileUploadSuccessMsg={this.state.fileUploadSuccessMsg}
        fileUploadErrorList={this.state.fileUploadErrorList}
        onFileUploadClick={this.onFileUploadClick}
        onfileUploadCancel={() => { this.setState({ fileUploadMode: false }) }}
        onfileUpload={this.onfileUpload}
        //
        statusUpdateMode={this.state.statusUpdateMode}
        onUpdateStatusClick={this.onUpdateStatusClick}
        onUpdateStatusCancel={() => { (this.setState({ statusUpdateMode: false })) }}
        //
        setFollowUpMode={this.state.setFollowUpMode}
        onSetFollowUpClick={this.onSetFollowUpClick}
        onSetFollowUpCancel={() => { (this.setState({ setFollowUpMode: false })) }}
        //
        checked={this.state.checked}
        onShowStarred={this.onShowStarred}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onShowStarred = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onDownloadClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let rowId = event.currentTarget.getAttribute('data-row-id')
    let parts = rowId.split(':', 3)
    this.setState({ downloadMode: true, selectedMesgDate: parts[0] })

    if (!accountId.startsWith('+')) {
      RestApiUtils.get(this.props.context,
        `/api/su/accounts/${accountId}/files/${parts[1]}/fileName/${parts[2]}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }

    if (accountId.startsWith('+')) {
      RestApiUtils.get(this.props.context,
        `/api/su/phoneNumber/${accountId}/files/${parts[1]}/fileName/${parts[2]}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onReplyClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let userId = event.currentTarget.getAttribute('data-id')
    let phone = event.currentTarget.getAttribute('data-phone')
    this.setState({ replyMode: true, selectedAccountId: accountId, selectedUserId: userId, selectedPhone: phone })
  }

  onUpdateStatusClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let messageDate = event.currentTarget.getAttribute('data-date')
    let phone = event.currentTarget.getAttribute('data-phone')
    this.setState({ statusUpdateMode: true, selectedAccountId: accountId, selectedMesgDate: messageDate, selectedPhone: phone })
  }

  onSetFollowUpClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let messageDate = event.currentTarget.getAttribute('data-date')
    let phone = event.currentTarget.getAttribute('data-phone')
    this.setState({ setFollowUpMode: true, selectedAccountId: accountId, selectedMesgDate: messageDate, selectedPhone: phone })
  }

  onFileUploadClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-acc-id')
    let userId = event.currentTarget.getAttribute('data-id')
    this.setState({ fileUploadMode: true, selectedAccountId: accountId, selectedUserId: userId })
  }

  onfileUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      fileUploadSubmitted: true,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: []
    })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.state.selectedAccountId}/users/${this.state.selectedUserId}/chatMessages/files/validation`,
      this.onfileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onfileUploadCallback = (response) => {
    this.setState({ fileUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null
        })
      }, 2000)
    }
  }
}

export default withRouter(ChatMessageListSF)
